import { useContext } from "react";
import { Context } from "../../../context/Context";
import { sendToAppText } from "./sendToAppText";

// Why an item cannot be sent (from the backend's eligibility): hidden and/or the
// list of missing fields. Nothing is decided here.
export default function SendBlockReason({ block }) {
  const { lang } = useContext(Context);
  const t = sendToAppText(lang);
  if (!block || block.pending) return null;
  const missing = (block.missing || []).map((field) => t.missingFields[field] || field);
  return (
    <div className="food-unavailable-reason" role="note">
      {block.hidden && <p>{t.cannotSendHidden}</p>}
      {missing.length === 1 && <p>{t.cannotSendMissingOne(missing[0])}</p>}
      {missing.length > 1 && (
        <>
          <p>{t.cannotSendMissing}</p>
          <ul>
            {missing.map((label) => (
              <li key={label}>{label}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
